enum DocumentSubjectStatusEnum {
    ACTIVE = 'active',
    INACTIVE = 'inactive'
}

export default DocumentSubjectStatusEnum
